<template>
  <div
    :class="classObject"
    class="ModalSide"
  >
    <div
      class="overlay"
      @click="hideModalSide"
    />

    <div class="ModalSide__content">
      <div class="ModalSide__header">
        <slot name="header" />
        <div
          class="ModalSide__toggler"
          @click="hideModalSide"
        >
          <i class="el-icon el-icon-close" />
        </div>
      </div>

      <div class="ModalSide__body">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalSide',
  props: {
    side: {
      type: String,
      default: 'left',
      validator: value =>
        // The value must match one of these strings
        ['left', 'right'].indexOf(value) !== -1
      ,
    },
  },
  computed: {
    classObject() {
      return {
        'ModalSide--left': this.side === 'left',
        'ModalSide--right': this.side === 'right',
      };
    },
  },
  methods: {
    hideModalSide() {
      this.$emit('hideModalSide', false);
    },
  },
};
</script>

<style scoped lang="scss">
.ModalSide {
  @include fixed-full-xy;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.3s linear, opacity 0.3s linear;
  @include z-index(modalSide);

  &.active {
    visibility: visible;
    opacity: 1;
  }

  .overlay {
    background: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
  }
}
.ModalSide__content {
  width: 100%;
  height: 100%;
  background: #fefefe;
  border-top: 1px solid transparent; //hack
  max-width: 375px;
  transition: all 0.3s;
  position: absolute;
  top: 0;
}
.ModalSide--left .ModalSide__content {
  left: -500px;
}
.ModalSide--left.active .ModalSide__content {
  left: 0;
}
.ModalSide--right .ModalSide__content {
  right: -500px;
}
.ModalSide--right.active .ModalSide__content {
  right: 0;
}
.ModalSide__header {
  height: 60px;
  padding-left: 25px;
  padding-right: 25px;
  border-bottom: $borderSeparator--light;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ModalSide__toggler {
  display: inline-block;
  padding: 0 5px;
  font-size: 24px;
  cursor: pointer;
  margin-left: auto;

  i {
    font-size: 20px;
    color: $color--primary;

  }
}
.ModalSide__body {
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow-y: scroll;
  height: calc(100% - 60px); // minus height of header
}
@include media-md() {
  .ModalSide__content {
    max-width: 415px;
  }
  .ModalSide__header {
    position: relative;
    padding-left: 45px;
    padding-right: 45px;
  }
  .ModalSide__body {
    padding-left: 45px;
    padding-right: 45px;
  }
}
@include media-xl() {
  .ModalSide__content {
    max-width: 450px;
  }
}
</style>
